import SubCategory from "./SubCategory";

export default SubCategory;
